import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import PageLoader from "./PageLoader";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, userProfile } = useAuth();

  if (loading) return <PageLoader />;

  // Check if user profile exists and has admin role
  const isAdmin = userProfile?.roles?.includes("admin") || false;

  if (!isAdmin || !isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
